import { createTheme } from "@mui/material/styles";


const theme = createTheme({
  typography: {
    "fontFamily": `"mulish"`,
  },
  palette: {
    primary: {
      main: '#B9FF00',
      dark: '#0066CC',
      background: '#1B1F18',
    },
    background: {
      paper: '#fff',
      black: '#0e0e0e',
      mainGradient: 'linear-gradient(264.22deg, #181A18 -124.15%, #0C0D0C 52.54%, #181A18 200.05%)',
    },

    secondary: {
      main: "#D1ADFF",
      light: "#E7D5FF"
    },
    text: {
      primary: '#173A5E',
      secondary: '#46505A',
    },
    action: {
      active: '#001E3C',
    },
    white: "#ffffff",
    black: "#000000",
    lightGray: "#dcdcdc",
    mediumGray: "#a9a9a9",
    darkGray: "#696969",
    littleWhite: "#EBEBEB",
    toughGrey: "#FEFFFACC",
    paleWhite: "#FFFFFFBF",
    gray: {
      500: "#989E93"
    },
  },
});

export default theme;